import React from "react";
import { IoClose } from "react-icons/io5";

const RenameUploadModal = ({
  renameModal,
  renameValue,
  setRenameValue,
  onClose,
  onRename,
  isPending = false,
  title,
  label,
  placeholder,
  saveLabel,
}) => {
  if (!renameModal) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-in fade-in duration-150">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-4 overflow-hidden animate-in zoom-in-95 duration-150">
        <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-100">
          <h2 className="text-base font-bold text-slate-900">
            {title || `Rename ${renameModal.type}`}
          </h2>
          <button
            onClick={onClose}
            disabled={isPending}
            className="p-1.5 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <IoClose size={18} />
          </button>
        </div>
        <div className="px-6 py-5">
          <label className="block text-xs font-semibold text-slate-700 mb-2">
            {label || "New Name"}
          </label>
          <input
            autoFocus
            value={renameValue}
            disabled={isPending}
            onChange={(e) => setRenameValue(e.target.value)}
            onKeyDown={(e) => {
              if (isPending) return;
              if (e.key === "Enter") onRename();
              if (e.key === "Escape") onClose();
            }}
            placeholder={placeholder || "Enter new name..."}
            className="w-full px-3.5 py-2.5 text-sm border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-400 transition-all bg-white text-slate-800 disabled:opacity-60 disabled:cursor-not-allowed"
          />
        </div>
        <div className="flex items-center justify-end gap-3 px-6 pb-6 pt-2 border-t border-slate-100 bg-slate-50/50">
          <button
            onClick={onClose}
            disabled={isPending}
            className="px-4 py-2 text-sm font-semibold text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onRename}
            disabled={!renameValue.trim() || isPending}
            className="px-5 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-xl transition-colors shadow-sm shadow-indigo-200"
          >
            {isPending ? (saveLabel ? "Saving..." : "Renaming...") : (saveLabel || "Rename")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenameUploadModal;
